export default __webpack_public_path__ + "static/media/error-result-image.0489d7c5.svg";